import type { LayoutMode } from './viewportMetrics';

export class AimingPointerTracker {
  private activePointerId: number | null = null;

  begin(layoutMode: LayoutMode, pointerId: number): void {
    if (layoutMode !== 'desktop' && this.activePointerId === null) this.activePointerId = pointerId;
  }

  acceptsMove(layoutMode: LayoutMode, pointerId: number, isDown: boolean): boolean {
    if (layoutMode === 'desktop') return true;
    return isDown && this.activePointerId === pointerId;
  }

  end(pointerId: number): void {
    if (this.activePointerId === pointerId) this.activePointerId = null;
  }

  cancel(): void {
    this.activePointerId = null;
  }
}
